<template>
    <div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">ข้อมูลออกใบกำกับภาษี / ใบเสร็จ</h6>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณต้องการคิดคิดภาษีมูลค่าเพิ่มหรือไม่
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio-group v-model="vatShop.vat" :state="($v.vatShop.vat.$error) ? false : null">
                                <b-form-radio :value="1" @input="toggleVat()">คิดภาษีมูลค่าเพิ่ม</b-form-radio>
                                <b-form-radio :value="0" @input="toggleVat()">ไม่คิดภาษีมูลค่าเพิ่ม</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                </div>
            </div>
            <template v-if="vatShop.vat == true">
                 <div class="col-lg-12">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> คุณต้องการคิดภาษีมูลค่าเพิ่มขนส่งหรือไม่ 
                            <template v-if="this.$THEME.name == 'shippop'">
                                <i class="fas fa-info-circle fa-xs text-primary"></i> 
                                <a class="a-tag color-tag px-1" @click="infoVat.show = true">
                                    <u>ตัวอย่าง</u>
                                </a>
                            </template>
                        </label>
                        <div class="col-lg-12">
                            <b-form-group>
                                <b-form-radio-group v-model="vatShop.vatCourier" :state="($v.vatShop.vatCourier.$error) ? false : null">
                                    <b-form-radio :value="1">คิดภาษีมูลค่าเพิ่มขนส่ง</b-form-radio>
                                    <b-form-radio :value="0">ไม่คิดภาษีมูลค่าเพิ่มขนส่ง</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </template>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> E-mail
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="E-mail"
                        :class="{ 'is-invalid': submittEdit && $v.vatShop.email.$error }"
                        v-model="vatShop.email"
                    />
                    <label v-if="submittEdit && !$v.vatShop.email.email" class="invalid-feedback">
                        รูปแบบอีเมลไม่ถูกต้อง
                    </label>
                    <label v-if="submittEdit && !$v.vatShop.email.required" class="invalid-feedback">
                        กรุณากรอกอีเมล
                    </label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> เลขประจำตัวผู้เสียภาษี
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="เลขประจำตัวผู้เสียภาษี"
                        :class="{ 'is-invalid': submittEdit && $v.vatShop.tax.$error }"
                        v-model="vatShop.tax"
                    />
                    <label class="error invalid-feedback" v-if="!$v.vatShop.tax.minLength">
                        กรุณากรอก"เลขประจำตัวผู้เสียภาษี"อย่างน้อย {{$v.vatShop.tax.$params.minLength.min}} ตัวอักษร
                    </label>
                    <label class="error invalid-feedback" v-if="!$v.vatShop.tax.maxLength">
                        กรุณากรอก"เลขประจำตัวผู้เสียภาษี"ไม่เกิน {{ $v.vatShop.tax.$params.maxLength.max }} ตัวเลข
                    </label>
                    <label v-if="submittEdit && !$v.vatShop.tax.required" class="invalid-feedback">
                        กรุณากรอกเลขประจำตัวผู้เสียภาษี
                    </label>
                    <label v-if="submittEdit && !$v.vatShop.tax.checkTax" class="invalid-feedback">
                        กรุณากรอกเลขประจำตัวผู้เสียภาษีให้ถูกต้อง
                    </label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> ที่อยู่
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': submittEdit && $v.vatShop.address.$error }"
                        placeholder="ที่อยู่"
                        v-model="vatShop.address"
                    />
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.vatShop.address.minLength"
                    >กรุณากรอก"ที่อยู่"อย่างน้อย {{$v.vatShop.address.$params.minLength.min}} ตัวอักษร</label>
                    <label
                        v-if="submittEdit && !$v.vatShop.address.required"
                        class="invalid-feedback"
                    >กรุณากรอกที่อยู่</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> ตำบล/แขวง
                    </label>
                    <AutocompletesAddress
                        :queryInput="vatShop.state" 
                        :adsTypes="'sub-district'"
                        placeHolder="ตำบล/แขวง"
                        :class="{ 'is-invalid': submittEdit && $v.vatShop.state.$error }"
                        @input="vatShop.state = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'vatShop' )">
                    </AutocompletesAddress>
                    <label
                        v-if="submittEdit && !$v.vatShop.state.required"
                        class="invalid-th-address"
                    >กรุณากรอกตำบล/แขวง</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> อำเภอ/เขต
                    </label>
                    <AutocompletesAddress
                        :queryInput="vatShop.district" 
                        :adsTypes="'district'"
                        placeHolder="อำเภอ/เขต"
                        :class="{ 'is-invalid': submittEdit && $v.vatShop.district.$error }"
                        @input="vatShop.district = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'vatShop' )">
                    </AutocompletesAddress>
                    <label
                        v-if="submittEdit && !$v.vatShop.district.required"
                        class="invalid-th-address"
                    >กรุณากรอกอำเภอ/เขต</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> จังหวัด
                    </label>
                    <AutocompletesAddress
                        :queryInput="vatShop.province" 
                        :adsTypes="'province'"
                        placeHolder="จังหวัด"
                        :class="{ 'is-invalid': submittEdit && $v.vatShop.province.$error }"
                        @input="vatShop.province = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'vatShop')">
                    </AutocompletesAddress>
                    <label
                        v-if="submittEdit && !$v.vatShop.province.required"
                        class="invalid-th-address"
                    >กรุณากรอกจังหวัด</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> รหัสไปรษณีย์
                    </label>
                    <AutocompletesAddress
                        :queryInput="vatShop.postcode" 
                        :adsTypes="'postcode'"
                        placeHolder="รหัสไปรษณีย์"
                        :class="{ 'is-invalid': submittEdit && $v.vatShop.postcode.$error }"
                        @input="vatShop.postcode = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'vatShop')">
                    </AutocompletesAddress>
                    <label
                    v-if="submittEdit && !$v.vatShop.postcode.required"
                    class="invalid-th-address"
                    >กรุณากรอกรหัสไปรษณีย์</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.vatShop.postcode.minLength"
                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.vatShop.postcode.$params.minLength.min}} หลัก</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.vatShop.postcode.maxLength"
                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.vatShop.postcode.$params.maxLength.max}} หลัก</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.vatShop.postcode.numeric"
                    >กรุณากรอกเฉพาะตัวเลข</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> เบอร์โทรศัพท์
                    </label>
                    <input
                        type="number"
                        class="form-control hide-arrow"
                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                        placeholder="เบอร์โทรศัพท์"
                        :class="{ 'is-invalid': submittEdit && $v.vatShop.tel.$error }"
                        v-model="vatShop.tel"
                    />
                    <label
                        v-if="submittEdit && !$v.vatShop.tel.required"
                        class="invalid-feedback"
                    >กรุณากรอกเบอร์โทรศัพท์</label>
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.vatShop.tel.minLength"
                    >กรุณากรอก"เบอร์โทรศัพท์"อย่างน้อย {{$v.vatShop.tel.$params.minLength.min}}ตัวเลข</label>
                </div>
            </div>
        </div>
        <ModalInfoVatShop :infoVat="infoVat" />
    </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  email,
  requiredIf
} from "vuelidate/lib/validators"
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'
import { checkTax } from "@/plugins/posHelper.js";
import ModalInfoVatShop from "../../Modals/ModalInfoVatShop.vue";

export default {
    props:{
        vatShop: Object,
        submittEdit: Boolean
    },
    components:{
        AutocompletesAddress,
        ModalInfoVatShop
    },
    data: () => ({
        infoVat:{
            show: false
        }
    }),
    validations:{
        vatShop:{
            vat: { required },
            vatCourier: { required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                })
            },
            tax:{ required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                }), minLength: minLength(13), maxLength: maxLength(13), checkTax
            },
            address: { required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                }), minLength: minLength(5) 
            },
            state: { required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                })
            },
            district: { required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                })
            },
            province: { required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                })
            },
            postcode: { required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                }), numeric, minLength: minLength(4), maxLength: maxLength(5) 
            },
            tel: { required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                }), minLength: minLength(9) 
            },
            email: { required: requiredIf(function (vatShop) {
                    return vatShop.vat == true
                }), email
            },
        }
    },
    methods:{
        toggleVat() {
            if (this.vatShop.vat) {
                this.vatShop.vatCourier = 1;
            } else {
                this.vatShop.vatCourier = 0;
            }
        },
        onSubmitAddress( ads , objKey ){
            Object.keys(this[objKey]).forEach(key=>{
                if( ads[key] ){
                    this[objKey][key] = ads[key]
                }else if( key == 'state' ){
                    this[objKey]['state'] = ads['sub-district']
                }
                else{
                    this[objKey][key] = this[objKey][key]
                }
            })
        }
    }
    
}
</script>